import {
  PRODUCTS_IMPORT_MESSAGES,
  ProductsImportMessages,
} from "./import-products-dialog.messages";
import { PRODUCT_FILTERS_MESSAGES, ProductFiltersMessages } from "./product-filter.messages";
import { PRODUCT_TABLE_MESSAGES, ProductTableMessages } from "./product-table.messages";
import { PRODUCT_REQUEST_MESSAGES, ProductRequestMessages } from "./product.request.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";

export type ProductsMessages = SidebarMessages &
  PopoverMessages &
  ActionButtonMessages &
  ProductTableMessages &
  ProductFiltersMessages &
  ProductRequestMessages &
  ProductsImportMessages & {
    // Title Messages
    pageTitle: string;
    breadCrumbTitle: string;
    productTableTitle: string;

    //Popover messages
    skuPopover: string;
    kitPopover: string;

    // Tooltip Messages for Expand/Collapse
    expandSku: string;
    collapseSku: string;

    //Buttons
    addProductButton: string;
  };

export const PRODUCTS_MESSAGES: ProductsMessages = {
  // Title Messages
  pageTitle: "Produtos",
  breadCrumbTitle: "Produtos",
  productTableTitle: "Listagem de Produtos",

  // Popover Messages
  skuPopover: "SKU",
  kitPopover: "KIT",

  // Tooltip Messages for Expand/Collapse
  expandSku: "Veja os SKUs deste produto",
  collapseSku: "Recolher SKUs",

  // Buttons
  addProductButton: "Novo Produto",

  ...PRODUCT_REQUEST_MESSAGES,
  ...PRODUCT_FILTERS_MESSAGES,
  ...PRODUCT_TABLE_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...POPOVER_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...PRODUCTS_IMPORT_MESSAGES,
};
